<template>
  <div>
    <p>
      Enter the verification code from your Authenticator app.
    </p>
    <form v-on:submit.prevent="login">
      <FieldWrapper>
        <div slot="input">
          <CodeInput :numberOfFields="6" :disabled="loading" @input="setCode" />
        </div>
        <input
          type="hidden"
          v-model="code"
          name="code"
          placeholder="CODE"
          v-validate="validatorDefinitions.authCode"
          data-vv-scope="code"
          maxlength="6"
        />
      </FieldWrapper>
    </form>
    <Divider />
    <DecoratedButton class="short plain" @click="$emit('reset')">
      <small>Unable to verify?</small>
    </DecoratedButton>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import CodeInput from "@/components/partials/auth/Code";

import Loader from "vue-spinner/src/BounceLoader";

export default {
  name: "auth-modal-two-factor-verify",
  components: { CodeInput, Loader },
  data: function() {
    return {
      code: null
    };
  },
  computed: {
    ...mapGetters("user", {
      loading: "getTwoFactorLoading"
    })
  },
  methods: {
    ...mapActions("user", {
      twoFactor: "twoFactor"
    }),
    close() {
      this.$emit("close");
    },
    login() {
      this.$validator.validateAll("code").then(valid => {
        if (valid && !this.loading) {
          this.twoFactor(this.code);
        }
      });
    },
    setCode(code) {
      const oldCode = this.code;
      this.code = code;

      if (this.code !== oldCode) {
        this.login();
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.loader-wrapper {
  display: inline-block;
}
</style>
